// Users module

define('modules/User/ClientUser',[
    'jquery',
    'global/all',
    './Users',
    './Users.Forms',
    '../Cart/CartManager'
], function ($, Roc, Users, ClientUserForms,cartManager) {
    'use strict';

    Users.initLogin = initClientLogin;
    var loginClientOptions;
    var loginClientData;
    //var registrationOptions;
    //var registrationData;

    //var forgotPasswordOptions;
    //var changePasswordData;
    //var editAccountOptions = {};
    //var editAccountData;

    // Forms definitions
    var clientForms = ClientUserForms;


    var buttons = {
        address: {
            btns: {
                btnUseThis: {
                    cssClass: 'useThisShippingAddress',
                    text: 'Start Shopping'
                },
                btnSelected: {
                    cssClass: 'selectedShippingAddres',
                    text: 'Starting...'
                }
            }
        },
        shipping: {
            btns: {
                btnUseThis: {
                    cssClass: 'useThisShippingMethod',
                    text: 'Use this method'
                },
                btnSelected: {
                    cssClass: 'selectedShippingMethod',
                    text: 'Selected method'
                }
            }
        }
    };

    //  Enter handlers
    function handleClientLoginEnterEvt() {
        Roc.Core.handleEnter('#login_email, #login_password', clientLogin);
    }

    // Specific events

    var btns = {
        clientLogin: '#clientLoginBtn',
    };

    function loginClientEvt() {
        $(document).on('click', btns.clientLogin, function () {
            clientLogin();
        });
    }

    // START: Events binding

    function bindClientLoginEvents() {
        handleClientLoginEnterEvt();
        loginClientEvt();
    }

    // START: Public Methods
    function initClientLogin(options) {
        loginClientOptions = options || {};
        loginClientData = {
            'email': Roc.Validation.getField(clientForms.Login, 'Email')
        };
        bindClientLoginEvents();
        $("#clientSelectContainer").hide();
    };

    function clientLogin() {
        console.log("ClientLogin");
        var $formWrapper = $(clientForms.Login.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(clientForms.Login);

        if (isValid) {
            Roc.Core.lockButton(btns.login);
            var requestData = Roc.Validation.getFieldValues(clientForms.Login);

            requestData.isCheckout = loginClientOptions.isCheckout || false;

            $.ajax({
                url: '/ajax/Login',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(requestData),
                beforeSend: loginClientOptions.beforeSend || null,
                complete: function (xhr) {
                    Roc.Core.releaseLockedButton(btns.login);

                    var response = xhr.responseJSON || {};
                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                            $errorContainer.html(renderedTemplate);
                        });
                    } else {
                        //removed per client - Ticket#410814 , where client said , they don't want the customer to see all those addresses to select , it should be defaulted to one of the organizations
                        Roc.Core.lockButton('#clientLoginBtn');
                        Roc.EventManager.notify(Roc.Events.users.LOGIN, xhr);
                        window.location.replace(response.redir);
                    }                    
                }
            });
        }
        
    }

    function clientSelectedAddressEvt() {
        Roc.UI.btnUseThisClickEvt(buttons.address.btns, function (addressId, $itemSource) {
            //var cart = CartManager.getCurrentCart();
            var requestData = {
                AddressId: addressId,
                OrderId: '00000000-0000-0000-0000-000000000000',
                UserId: '00000000-0000-0000-0000-000000000000',
                RemoteIp: ':::1'
            };
            $.ajax({
                url: '/ajax/addressselect',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(requestData),
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.success && response.redirectUrl) {
                        window.location.replace(response.redirectUrl);
                    } else {
                        Roc.UI.ajaxErrorPopup(xhr);
                    }
                }
            });
        }
        );
    }
});

